/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'launch-config';

export const launchConfigModalBreadcrumbTitle = `${prefix}.launchConfigModalBreadcrumbTitle`;

export const ENGLISH = {
    [launchConfigModalBreadcrumbTitle]: 'Launch Config',
};
